import { Statistic } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { numberMask } from "../../../../../../../services/helpersMethodsService";
import useLotDetailsSupplementSupplyContext from "../../../../../../../hooks/useLotDetailsSupplementSupplyContext";

// import { Container } from './styles';

function CardTotalCostSupplementSupplyDashboard() {
  const { totalCost } = useLotDetailsSupplementSupplyContext();
  const { translation } = useSelector((state) => state.app);
  return (
    <Statistic
      title={
        translation.lot.production.details.supplementSupply.dashboards.totalCost
      }
      value={numberMask(totalCost, true)}
    />
  );
}

export default CardTotalCostSupplementSupplyDashboard;
